import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['vuex_h5']),
  },
}